import React, { useEffect, useState } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { put } from "../../utility/fetch";
import GhostTextCompletion from "../layouts/TextPrediction";

function QueueLabWorkModal({ details, labRequest, closeModal }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [payload, setPayload] = useState({})
    const [labTechs, setLabTechs] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedServices, setSelectedServices] = useState();
    const { patientInfo } = usePatient()
    const navigate = useNavigate()

    const isMobile = window.innerWidth < 768;

    console.log(details)
    console.log(labRequest)

    const openModal = () => {
        setIsModalOpen(true);
    };

    const handleLabTechChange = (event) => {
        console.log(event)
        setSelectedServices(event?.value);
        // setPayload({...payload, labTechnicianId: event.target.value });
    };

    const getlabtech = async () =>{
        const response = await axios.get(`${process.env.REACT_APP_SERVICES_URL}/profile/profilebyhealthcareproviderid/${sessionStorage?.getItem("clinicId")}`);
        console.log(response);
        // const data = await response.json()
        setLabTechs(response.data);
        // return data;

    }


     const submitInternalLabRequest = async () => {
        setLoading(true);
            try {
                let res = await put(`/referredpatient/${details?.id}/patient/${details?.patient?.id}/assign-lab-technician-to-internal-lab-service`,
                    {
                        labServices: [
                            {
                                testRequestId: labRequest?.id,
                                labTechnicianId: selectedServices
                            }
                        ]
                    }
                );
                if (res.statusCode === 200) {
                    // payInternalLabRequest();
                    console.log(res)
                    openModal();
                    setLoading(false);
    
                }
                else{
                    // openModal();
                    setLoading(false);
                    console.log(res)
                    // handleError(res);
                }
                console.log(res);
            } catch (error) {
                console.error('Error submitting internal lab request:', error);
                setLoading(false);
            }
        }


    useEffect(() => {
        getlabtech();
        
    },[]);

    const close = () => {
        setIsModalOpen(false);
        closeModal();
        navigate('/procedures');
    };

    const labSpecialists = [
        { name: 'Dr. Alice Smith', specialty: 'Hematology', value: 1 },
        { name: 'Dr. Bob Johnson', specialty: 'Microbiology', value: 2 },
        { name: 'Dr. Carol Williams', specialty: 'Pathology', value: 3 },
        { name: 'Dr. David Brown', specialty: 'Radiology', value: 4 },
        { name: 'Dr. Emma Davis', specialty: 'Immunology', value: 5 },
        { name: 'Dr. Frank Miller', specialty: 'Genetics', value: 6 },
        { name: 'Dr. Grace Wilson', specialty: 'Biochemistry', value: 7 },
        { name: 'Dr. Henry Moore', specialty: 'Cytology', value: 8 },
        { name: 'Dr. Irene Taylor', specialty: 'Virology', value: 9 },
        { name: 'Dr. Jack Anderson', specialty: 'Toxicology', value: 10 }
    ];

    const handleTranscript = (transcript) => {
        setPayload(prevPayload => ({ ...prevPayload, referralNotes: prevPayload.referralNotes ? prevPayload.referralNotes + ' ' + transcript : transcript }));
    };

    return (
        <div className="modal ">
            <RiCloseFill className='close-btn pointer' onClick={closeModal} />
            <div className="modal-contents flex flex-direction-v flex-v-center ">
                <div className="w-100">
                    <div className="">
                        <h2>Queue Lab Work</h2>
                        <div className=" tabs m-t-10 bold-text"></div>
                        <div className="m-l-40 col-10 cards no-border p-20" style={isMobile ? { marginLeft: 0, width: '100%', padding: '10px' } : {}}>
                            <div className="flex space-between" style={isMobile ? { flexDirection: 'column', gap: '10px' } : {}}>
                                <div className="col-6" style={isMobile ? { width: '100%' } : {}}>
                                    <TagInputs label="Patient's Name" value={`${details?.patient?.firstName} ${details?.patient?.lastName}`} readOnly />
                                </div>
                                <div className="col-6" style={isMobile ? { width: '100%' } : {}}>
                                    <TagInputs label='Clinic' value={details?.initiatedHealthCareProvider?.name} readOnly />
                                </div>
                            </div>
                            <div className="flex space-between" style={isMobile ? { flexDirection: 'column', gap: '10px' } : {}}>
                                <div className="col-6" style={isMobile ? { width: '100%' } : {}}>
                                    <TagInputs label="Doctor's Name" value={`${details?.doctor?.firstName} ${details?.doctor?.lastName}`} readOnly />
                                </div>
                                {/* <div className="col-6">
                                    <TagInputs label='Severity' value={details?.severity} readOnly />
                                </div> */}
                            </div>
                            <div className="flex space-between" style={isMobile ? { flexDirection: 'column', gap: '10px' } : {}}>
                                <div className="col-6" style={isMobile ? { width: '100%' } : {}}>
                                    <TagInputs label='Date Initiated' value={new Date(details?.createdAt).toLocaleDateString()} readOnly />
                                </div>
                                <div className="col-6" style={isMobile ? { width: '100%' } : {}}>
                                    <TagInputs label='Time Initiated' value={new Date(details?.dateAndTimeInitiated).toLocaleTimeString()} readOnly />
                                </div>
                            </div>

                            <table className="bordered-table m-b-20 ">
                                <thead>
                                    <tr>
                                        <th>Lab Request</th>
                                        <th>Route Request to Technician</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {details?.testRequests?.map((work, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}. {work?.referredInternalLabService?.name}</td>
                                            <td>
                                                <TagInputs
                                                    label="Select Lab Specialist"
                                                    options={labTechs?.map(specialist => ({
                                                        label: `${specialist.firstName} ${specialist.lastName}`,
                                                        value: specialist.id
                                                    }))}
                                                    name={`labSpecialist${index}`}
                                                    onChange={handleLabTechChange}
                                                    type='R-select'
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div>
                                <TagInputs label="Doctor's Diagnosis" type='textArea' value={details?.diagnosis} readOnly multiline />
                            
                            </div>
                            <div>
                                {/* <TagInputs label='Additional Notes' type='textArea' value={details?.notes} readOnly multiline /> */}
                            </div>
                            <button disabled = {loading} onClick={submitInternalLabRequest} className="submit-btn m-t-20">Proceed With Request</button>
                        </div>
                    </div>
                    {isModalOpen &&
                        <SuccessModal Name={`${details?.firstName} ${details?.lastName}`} closeModal={close} />
                    }
                </div>
            </div>
        </div>

    );
}

export default QueueLabWorkModal;
